import axios from "axios";

const axiosInstance = axios.create();

const performLogout = () => {
  localStorage.clear();
  sessionStorage.clear();
  if(window.location.pathname !== "/")
  {window.location.href =  '/';}
};

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      performLogout();
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;